import { TribeClient } from '@tribeplatform/gql-client';
export const getTokens = async (config) => {
    var _a;
    const { networkDomain, networkId, otp } = config;
    if (!networkDomain && !networkId && !otp) {
        throw new Error('Please provide either of these arguments to proceed: networkDomain, networkId or otp');
    }
    let graphqlUrl = config === null || config === void 0 ? void 0 : config.baseUrl;
    if (!graphqlUrl && typeof process !== 'undefined') {
        graphqlUrl = (_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.TRIBE_GQL_ENDPOINT;
    }
    const client = new TribeClient({
        accessToken: config === null || config === void 0 ? void 0 : config.accessToken,
        onError: config === null || config === void 0 ? void 0 : config.onError,
        onEvent: config === null || config === void 0 ? void 0 : config.onEvent,
        graphqlUrl,
    });
    const authToken = await client.getTokens({
        networkDomain,
        networkId,
        otp,
    }, 'default');
    client.setToken(authToken === null || authToken === void 0 ? void 0 : authToken.accessToken);
    return { authToken, client };
};
//# sourceMappingURL=getTokens.js.map